<template>
  <booking-section id="flight-details" :title="$t('booking.sectionTitles.flightDetails')" :collapsed="moduleCollapsed" contentClass="">
    <div v-if="loaded">
      <div class="booking-element" v-html="result.prices_table"></div>
      <div class="booking-element">
        <div v-html="result.flight_plan"></div>
        <table class="booking-prices">
          <tfoot class="flight_details__footer">
            <tr>
              <td colspan="7">
                <div class="spacer">
                  <b>aktueller Gesamtpreis inkl. Flug: {{resultData[0].total}}</b>
                  <br/>
                  <div class="spacer"><a class="metainfo small">Klicken Sie hier um Details zu den enthaltenen Steuern und Gebühren zu erhalten</a></div>
                  <a class="cta" @click="sendBookingProceed">Bestätigen und fortfahren</a>

                </div>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>

    </div>
    <loader v-else title="Flugdetails werden geladen" details="Einen Moment bitte"></loader>
    <div id="fare-rules-overlay" class="reveal" data-reveal="" v-if="result && result.segment_fares && result.segment_fares.length > 0">
      <div class="inner">
        <loader v-if="rulesLoading" title="Tarifdetails werden geladen" details="Einen Moment bitte"></loader>
        <div class="rule-tabs">
          <div :class="`rule-tab ${i == currentRule ? 'active' : ''}`" @click="checkRules(i)" v-for="(seg,i) in result.segment_fares">
            {{ seg.route }}
          </div>
        </div>
        <div class="rule-wrapper" v-for="(rule,i) in fareRules">
          <b class="rule-header product-list-description" @click="toggleRules(i)">
            {{ rule.name }}
            <div class="arrow-indicator close"></div>
          </b>
          <div class="rule-content" style="display: none;">
            <pre v-for="d in rule.data">{{ d }}</pre>
          </div>
        </div>
      </div>
      <button class="close-button" aria-label="Popup schließen" data-close="" type="button">Fenster schließen ( x )</button>
    </div>
  </booking-section>
</template>

<script>

import axios from 'axios'
import resultLoader from '../booking/mixins/resultLoader'
import bookingDefaults from '../booking/mixins/bookingDefaults'

export default {
  mixins: [resultLoader, bookingDefaults],
  watch: {
    resultData: {
      handler(res){
      }
    },
    'loaded': {
      handler(newval, oldval){
       this._.delay(this.bindTarifLinks, 1000);
      }

    }
  },
  data(){
    return {
      getServicesUrl: `${process.env.BASE_URL}/api/booking/${this.productId}/get_services`,
      checkRulesUrl: `${process.env.BASE_URL}/api/booking/${this.productId}/check_rules`,
      fareRules: [],
      currentRule: 0,
      currentStep: 'flightDetails',
      rulesLoading: false,
    }
  },
  methods: {

    sendBookingProceed(){
      var params = {
        flight_proposal_id: this.result.flight_proposal_id,
        calculation_data: JSON.stringify(this.result.calculation_data),
        price: this.resultData[0].price
      }
      this.$emit('next-started')
     axios.get(this.getServicesUrl, {params: params} )
      .then(response => {
       this.$emit('next-loaded', response.data)
      })

    },
    checkRules(i){
     this.fareRules = []

      if ($("body > .reveal-overlay:visible").length == 0  ){
        new Foundation.Reveal($("#fare-rules-overlay")).open()
      }

     this.currentRule = i
     this.rulesLoading = true
     axios.get(this.checkRulesUrl, { params: {fare_session: this.result.fare_session, fare_index: this.result.segment_fares[i].fare_index }} )
      .then(response => {
         this.fareRules = response.data.rules
         this.rulesLoading = false
      })
    },
    toggleRules(i){
      $($(".rule-header")[i]).toggleClass('open')
      $($(".rule-header .arrow-indicator")[i]).toggleClass('close')
      $($(".rule-content")[i]).slideToggle()
    },
    bindTarifLinks(){
      $('a.check-rules-link').each((i,e) => {
        $(e).click(() => {
          if (this.rulesLoading != true) {
            this.checkRules(i)
          }
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>